import { render } from "./PhrasesPage.vue?vue&type=template&id=774399c2&scoped=true"
import script from "./PhrasesPage.vue?vue&type=script&lang=js"
export * from "./PhrasesPage.vue?vue&type=script&lang=js"

import "./PhrasesPage.vue?vue&type=style&index=0&id=774399c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774399c2"]])

export default __exports__